/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    Renderer2,
} from '@angular/core';

import './avi-label-with-tooltip.less';

@Component({
    selector: '[aviLabelWithTooltip]',
    templateUrl: './avi-label-with-tooltip.component.html',
})
export class AviLabelWithTooltipComponent implements AfterViewInit {
    /**
     * @param tooltipText - Custom text unrelated to Schema to be shown.
     */
    @Input() public tooltipText = '';

    /**
     * @param objectType - The Schema object type that the field belongs to.
     */
    @Input() public objectType = '';

    /**
     * @param fieldName - The Schema field that contains the description text.
     */
    @Input() public fieldName = '';

    /**
     * @param hideRange - If true, hides the range text.
     */
    @Input() public hideRange = false;

    /**
     * @param enumType - The Schema enum type that the enum value belongs to.
     */
    @Input() public enumType = '';

    /**
     * @param enumValue - The Schema enum value that maps to contains the description text.
     */
    @Input() public enumValue = '';

    /**
     * @param for - Label "for" attribute.
     */
    @Input() public for = '';

    /**
     * If objectType is not available, we use range passed for showing value of range text.
     */
    @Input()
    public rangeText = '';

    /**
     * @param required - If the required binding exists or is equal to true, set this.required to
     *     true.
     */
    @Input('required') private set setRequired(required: boolean | '') {
        this.required = required === '' || required;
    }

    /**
     * Set to true to remove bolding from label. Default label is bold.
     */
    @Input()
    public noBold: boolean;

    public required = false;

    constructor(
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef,
    ) {}

    /**
     * @override
     * Add an id attribute to the label for accessibility purposes.
     */
    public ngAfterViewInit(): void {
        const { nativeElement } = this.elementRef;

        this.renderer.setAttribute(nativeElement, 'id', `${this.for}__avi-label-with-tooltip`);
    }
}
